import { type PropsWithChildren, memo } from "react";

import { type TTailwindString } from "classnames";

type Props = {
  className?: TTailwindString;
};

const BadgeViewBase = ({ children, className }: PropsWithChildren<Props>) => {
  return <span className={className}>{children}</span>;
};

export const BadgeView = memo(BadgeViewBase);
